/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { ajax, Status, arrayFrom, getState, isEmpty} from '../../../twd/twd'
import useMarketNews from '../use-market-news'

const state = getState('municipals.use-search-holding', {
    holdings: []
})

export default () => {
    const {
        holdings:selected,
        setHoldings:setSelected,
    } = useMarketNews()
    const [status, setStatus] = React.useState(Status.LOADING)
    const [error, setError] = React.useState('')

    React.useEffect(() => {(async () => {
        try {
            setError('')
            setStatus(Status.LOADING)
            let {data} = await ajax({
                url: '/esb/retailservice/bitvoreNewsAPIService/getUserHoldingsList',
                method: 'POST',
                params: {
                    invTypes: ['M']
                }
            })

            let a = arrayFrom(await data)

            let rs = Object.values(a
                .filter(i => i.issue)
                .reduce( (x,i)=> {
                    let d = i.issue
                    if (!d || !(d.trim())) return x

                    let n = i.cusip
                    if (!x[n]) {
                        x[n] = { qty:0, cusip:n, label: d.trim() }
                    }

                    x[n].qty += i.qty
                    return x
                }, {}))
                .sort( (a,b) => b.qty - a.qty )
                .slice(0,10)
                .sort( (a,b) => {
                    if (b.label > a.label) return -1
                    if (b.label < a.label) return 1
                    return 0
                })

            state.set({ holdings:rs })

            if (isEmpty(selected)) {
                setSelected(rs)
            }

            setStatus(Status.LOADED)
        } catch(e) {
            setStatus(Status.FAILED_TO_LOAD)
        }
    })()}, [])

    return {
        selected, setSelected,
        status, error,
    }
}



